/**
 * What the plane shows in each state of the level (GDD §4.1, §3.4, §6.1, issue #67), as a pure function of
 * the state of the core. The render decides no durations: the blink is the flag of the core (3 ticks on,
 * 3 off at 60 Hz) and DERRIBO lasts what the level state machine says. The crash is comic and nobody dies:
 * smoke, no fire and no blood, and the pilot jumps out under a parachute.
 */
export interface PlayerViewInput {
  levelState: string;
  /** Ticks since DERRIBO began; 0 outside it. */
  derriboTicks: number;
  invulnerable: boolean;
  /** The blink flag of the core (#37). */
  blinkVisible: boolean;
  reducedMotion: boolean;
}

export interface PlayerViewModel {
  airframeVisible: boolean;
  bagVisible: boolean;
  /** 1, or 0.5 when reduced motion replaces the blink while invulnerable (@gdd-pending). */
  opacity: number;
  smoke: boolean;
  pilot: boolean;
  parachute: boolean;
}

/** The pilot jumps out in the first third of DERRIBO and the parachute opens at 0.5 s (GDD §11.1). */
export const PILOT_TICK = 10;
export const PARACHUTE_TICK = 30;
export const REDUCED_MOTION_OPACITY = 0.5;

export function playerViewModel(input: PlayerViewInput): PlayerViewModel {
  if (input.levelState === 'DERRIBO') {
    return {
      airframeVisible: true,
      bagVisible: true,
      opacity: 1,
      smoke: true,
      pilot: input.derriboTicks >= PILOT_TICK,
      parachute: input.derriboTicks >= PARACHUTE_TICK,
    };
  }
  // Invulnerability: blink with the flag of the core, or a steady translucent model with reduced motion.
  const visible = input.reducedMotion ? true : input.blinkVisible;
  return {
    airframeVisible: visible,
    bagVisible: visible,
    opacity: input.reducedMotion && input.invulnerable ? REDUCED_MOTION_OPACITY : 1,
    smoke: false,
    pilot: false,
    parachute: false,
  };
}
